export const updateMaterialAvailability = `mutation EditMaterialAvailability($input: EditMaterialAvailabilityRequest!) {
  editMaterialAvailability(input: $input) {
    status
    message
  }
}`